<template>
  <div>
    <v-container fluid class="lighten-12 content">
      <v-container fluid>
        <v-row>
          <v-card-text class="pa-0">
            <v-row>
              <v-col
                cols="12"
                lg="4"
                sm="12
              m10"
              >
                <v-autocomplete
                  hide-details="auto"
                  :items="shops"
                  :loading="loadingShops"
                  v-model="selectedShop"
                  @input="getAllProducts(searchDate)"
                  item-text="name"
                  item-value="id"
                  label="Shop"
                  outlined
                  dense
                ></v-autocomplete>
              </v-col>
              <v-col cols="4"></v-col>
              <v-col cols="12" lg="3" sm="12">
                <DatePicker
                  :labelname="'Date'"
                  v-model="searchDate"
                  @input="getAllProducts(searchDate)"
                  :max="Datemax"
                />

                <!-- <v-text-field
                    hide-details="auto"
                    v-model="search"
                    dense
                    outlined
                    clearable
                    @input="getAllProducts(search)"
                    placeholder="Search"
                    append-icon="mdi-magnify"
                ></v-text-field> -->
              </v-col>
              <v-col cols="12" sm="12" lg="12">
                <TableHeaderFilter :columns="columns" />
              </v-col>
            </v-row>

            <v-card-title class="d-flex justify-space-between"
              >Stock Details
              <v-btn
                hidden
                small
                class="text-white btn_gray w-100 d-none d-sm-flex"
                v-print="printQr"
                >Print <v-icon right dark> mdi-printer </v-icon></v-btn
              ></v-card-title
            >

            <!-- {{products}} -->
            <StockProductsTemplate
              :datas="data"
              :data="productDetails"
              class="test1"
              id="shopproducts"
              :columns="columns"
              style="display: none"
            />
            <v-simple-table fixed-header dense>
              <template v-slot:default>
                <div
                  v-if="productDetails.length == 0"
                  class="mt-16 container justify-center item-center"
                >
                  <img
                    style="height: 200px"
                    src="../../assets/img/no-result.jpg"
                  />
                </div>
                <thead v-if="productDetails.length > 0">
                  <tr>
                    <th
                      class="text-left"
                      v-if="col.show"
                      v-for="(col, index) in columns"
                    >
                      {{ col.text }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in productDetails" :key="item.name">
                    <td v-if="columns[0].show">{{ index + 1 }}</td>
                    <td v-if="columns[1].show">{{ item.product.name }}</td>
                    <td v-if="columns[2].show">{{ item.date | formatDate }}</td>
                    <td v-if="columns[3].show">{{ item.unit.name }}</td>
                    <td v-if="columns[4].show">{{ item.batch.batch }}</td>
                    <td v-if="columns[5].show">{{ item.available_stock }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-row>
      </v-container>
    </v-container>
    <div class="d-flex justify-center align-center"></div>
  </div>
</template>
<script>
import PageTitle from '@/components/shared/PageTitle';
import TableFilters from '@/components/base/TableFilters';
import { Product } from '@/models/Product';

import DatePicker from '@/components/base/DateComponent.vue';

import StockProductsTemplate from '@/components/PrintTemplates/StockDetailsTemplate.vue';
import moment from 'moment';
export default {
  data: () => ({
    shops: [],
    searchDate: moment(new Date()).subtract(1, 'days').format('YYYY-MM-DD'),
    Datemax: moment(new Date()).subtract(1, 'days').format('YYYY-MM-DD'),
    products: [],
    search: null,
    selectedShop: null,
    data: {
      type: 'Shop ',
      shop: null,
    },
    productDetails: [],
    loadingShops: false,
    columns: [
      {
        text: 'No',
        show: true,
        width: '20%',
      },
      {
        text: 'Name',
        show: true,
        disabled: true,
        width: '20%',
      },
      {
        text: 'Date',
        show: true,
        width: '20%',
      },

      {
        text: 'Unit',
        show: true,
        width: '20%',
      },

      {
        text: 'Batch',
        show: true,
        disabled: true,
        width: '20%',
      },

      {
        text: 'Available Stock',
        show: true,
        align: 'center',
        width: '20%',
      },
    ],
  }),
  components: {
    PageTitle,
    TableFilters,
    StockProductsTemplate,
    DatePicker,
  },

  methods: {
    async getAllProducts(value) {
      await this.$store
        .dispatch('report/GetShopStockDetails', {
          query: value,
          shopId: this.selectedShop,
        })
        .then((res) => {
          this.data.shop = this.shops.find((p) => p.id == this.selectedShop);

          this.products = res.data.data;

          this.productDetails = this.products;
          ///  this.productDetails.map((p) => (p.available_stock = p.quantity));
        })
        .catch((err) => {});
    },
    async getAllShops(value) {
      await this.$store
        .dispatch('shop/GetShop', {})
        .then((res) => {
          this.shops = res;
          this.selectedShop = 1;
          this.getAllProducts(this.searchDate);
        })
        .catch((err) => {});
    },
  },

  created() {
    this.getAllShops('');
  },
  computed: {
    printQr() {
      return {
        id: 'shopproducts',
        popTitle: 'Product Details',
      };
    },
  },
};
</script>
